import React from 'react'
import { DynamicTextHighlightProps } from './DynamicTextHighlight.types'
import { HighlightSpan, MainContainer } from './styles'

const MATCHING_RGX = /\{\{([0-9]+)\}\}/g

function isInvalid(arr: unknown[]): boolean {
  return arr.some(
    (item) =>
      !item ||
      typeof item !== 'object' ||
      !('color' in item) ||
      !('value' in item) ||
      typeof item.color !== 'string' ||
      typeof item.value !== 'string'
  )
}

function DynamicTextHighlight({
  baseText,
  interpolationItems,
  ...divProps
}: DynamicTextHighlightProps) {
  const texts = baseText.split(MATCHING_RGX)

  if (
    baseText.search(MATCHING_RGX) === -1 ||
    interpolationItems.length === 0 ||
    isInvalid(interpolationItems)
  ) {
    return (
      <MainContainer>
        <span>{baseText}</span>
      </MainContainer>
    )
  }

  return (
    <MainContainer {...divProps}>
      <span>{texts[0]}</span>

      {texts.slice(1).map((text, idx, arr) => {
        if (idx % 2 === 0) {
          return null
        }

        const itemIdx = parseInt(arr[idx - 1])

        if (itemIdx >= interpolationItems.length) {
          console.error(
            'Algum índice seria acessado incorretamente, verifique o texto base'
          )
          return null
        }

        const item = interpolationItems[parseInt(arr[idx - 1])]

        return (
          <React.Fragment key={text + idx}>
            <HighlightSpan $color={item.color}>{item.value}</HighlightSpan>
            <span>{text}</span>
          </React.Fragment>
        )
      })}
    </MainContainer>
  )
}

export default DynamicTextHighlight
